import { useState, useEffect, useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ProductContext } from "../context/AppContext";
import Header from "./Header";
import Swal from "sweetalert2";
import { Select } from "antd";

const StudentUpdateGatePass = () => {
  const navigate = useNavigate();
  const {
    StaffData,
    Class,
    allClass = [],
    Section = [],
    GetstudentData,
    userData,
  } = useContext(ProductContext);
  const [filteredStaff, setFilteredStaff] = useState([]);
  const { id } = useParams();

  const Getstudent_id = userData?.currentUser?.id;

  // const handleSelectChange = (e) => {
  //   const selectedFirstName = e.target.value;
  //   handleChange("contact_to", selectedFirstName); // Save only first_name
  // };

  const [formData, setFormData] = useState({
    class_section_id: GetstudentData?.class_section_id,
    student_id: Getstudent_id,
    guardian_name: "",
    guardian_mobile_no: "",
    accompanied_by: "",
    reason: "",
    date: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const authtoken = localStorage.getItem("token");

  useEffect(() => {
    const fetchSchoolRule = async () => {
      try {
        const response = await fetch(
          `https://api.mirai.healthcare/api/head/student-exit-pass/${id}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json, text/plain",
              "Content-Type": "application/json;charset=UTF-8",
              "x-auth": authtoken,
            },
          }
        );
        const data = await response.json();
        console.log(data, "Student gate pass single");
        if (data?.data) {
          const Gate_pass_data = data?.data?.[0];

          setFormData({
            id: Gate_pass_data?.id,
            class_section_id: Gate_pass_data?.class_section_id,
            student_id: Gate_pass_data?.student_id,
            guardian_name: Gate_pass_data?.guardian_name,
            guardian_mobile_no: Gate_pass_data?.guardian_mobile_no,
            accompanied_by: Gate_pass_data?.accompanied_by,
            reason: Gate_pass_data?.reason,
            // date: new Date(Gate_pass_data?.date).toLocaleDateString(),
            date: new Date(Gate_pass_data?.date).toISOString().split("T")[0],
          });
        }
      } catch (error) {
        console.error("Error fetching TODO:", error);
      }
    };

    fetchSchoolRule();
  }, [id, authtoken]);

  const handleChange = (field, value) => {
    if (value instanceof Blob) {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    const data = new FormData();

    data.append("class_section_id", formData?.class_section_id);
    data.append("student_id", formData?.student_id);
    data.append("guardian_name", formData?.guardian_name);
    data.append("guardian_mobile_no", formData?.guardian_mobile_no);
    data.append("accompanied_by", formData?.accompanied_by);
    data.append("reason", formData?.reason);
    data.append("date", formData?.date);

    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/head/student-exit-pass/${id}`,
        {
          method: "PUT",
          body: data,
          headers: {
            // "x-auth": `${authtoken}`,
            "x-auth": authtoken,
          },
        }
      );

      const responseText = await response.text();
      console.log("Response:", responseText);

      if (response.ok) {
        setSuccess(true);
        Swal.fire({
          title: "Success",
          text: "Student Gate Pass updated successfully!",
          icon: "success",
        });
        navigate("/StudentGatePass");
      } else {
        alert("Error updating gate pass.");
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `Error: ${error.message || "An unknown error occurred"}`,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const today = new Date().toISOString().split("T")[0];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <Header hideSearch={true} />
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Student Gate Pass</li>
                  <li>{formData?.date}</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header card-buttons">
                  <h5 className="card-title">Apply Student Gate Pass</h5>
                </div>
                <div className="card-body">
                  <form
                    className="needs-validation"
                    noValidate
                    onSubmit={handleSubmit}
                  >
                    <div className="form-row row">
                      <div className="col-md-4 mb-1">
                        <label className="form-label" htmlFor="name">
                          Guardian Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Guardian Name"
                          value={formData.guardian_name}
                          onChange={(e) =>
                            handleChange("guardian_name", e.target.value)
                          }
                          required
                        />
                      </div>
                      <div className="col-md-4 mb-1">
                        <label
                          className="form-label"
                          htmlFor="guardian_mobile_no"
                        >
                          Guardian Mobile Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="guardian_mobile_no"
                          placeholder="Guardian Mobile Number"
                          value={formData.guardian_mobile_no}
                          onChange={(e) =>
                            handleChange("guardian_mobile_no", e.target.value)
                          }
                          required
                        />
                      </div>

                      <div className="col-md-4 mb-1">
                        <label className="form-label" htmlFor="accompanied_by">
                          Accompanied By
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="accompanied_by"
                          placeholder="Accompanied By"
                          value={formData.accompanied_by}
                          onChange={(e) =>
                            handleChange("accompanied_by", e.target.value)
                          }
                          required
                        />
                      </div>

                      <div className="col-md-4 mb-1">
                        <label className="form-label" htmlFor="reason">
                          Reason
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="reason"
                          placeholder="Reason"
                          value={formData.reason}
                          onChange={(e) =>
                            handleChange("reason", e.target.value)
                          }
                          required
                        />
                      </div>

                      <div className="col-md-4 mb-1">
                        <label className="form-label" htmlFor="date">
                          Date
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          id="date"
                          name="date"
                          value={formData.date}
                          onChange={(e) => handleChange("date", e.target.value)}
                          min={today} // Set the minimum date to today
                          required
                        />
                      </div>
                    </div>

                    <button
                      className="btn btn-primary"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentUpdateGatePass;
